import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useDeleteSensorAttributeMutation,
  useGetSensorAttributesQuery,
} from '../../../../../redux/services/sensorAttributes';
import { Spinner } from '../../../../common';
import { SensorsAttributesTable } from './SensorsAttributesTable';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

export function SensorsAttributesPage() {
  const { t } = useTranslation();
  const { sensorId } = useParams();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const {
    data: attributes,
    isLoading,
    refetch,
  } = useGetSensorAttributesQuery(sensorId);

  const [deleteSensorAttribute, { isSuccess }] =
    useDeleteSensorAttributeMutation();

  useEffect(() => {
    if (isSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa atribútov senzora')}
        backUrl={routes.cmsMeteoStationSensors}
        backUrlTooltip={t('Správa senzorov')}
        createText={t('Nový atribút')}
        createUrl={routes.cmsMeteoStationSensorsAttributesCreate(sensorId)}
        permissionsBasic={'meteo-station'}
      />

      <div style={{ margin: '10px' }}>
        <SensorsAttributesTable
          attributes={attributes}
          onEditClick={(attribute) =>
            navigate(
              routes.cmsMeteoStationSensorsAttributeEdit(
                sensorId,
                attribute.id,
              ),
            )
          }
          onDelete={(attribute) =>
            deleteSensorAttribute({
              sensorId: sensorId,
              attributeId: attribute.id,
            })
          }
        />
      </div>
    </>
  );
}

export default SensorsAttributesPage;
